import type { TweetListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoTweetType } from './tweetListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoTweetType';

/**
 * 트윗 기본 정보
 */
export type TweetListResponsePageAllOfThreeContentItemBasicInfoAllOfTwo = {
  content: string;
  /** 트윗 유형 */
  tweetType?: TweetListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoTweetType;
};
